<template>
  <transition name="page-footer">
    <div id="page-footer" v-show="show">
      <span class="copyright">© F8th Inc. 2018-{{ new Date().getFullYear() }}</span>
      <span class="split">-</span>
      <ButtonBasic :label="lang.privacy" @click.native="privacyPolicy" />
      <span class="split">-</span>
      <LanguageBar />
      <img src="@/assets/images/wcag-2-aaa.png" alt="WCAG 2.0 AAA" class="wcag" />
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { scrollY } from "@/assets/js/utils"
import ButtonBasic from "@/components/shared/button/ButtonBasic";
import LanguageBar from "@/components/shared/LanguageBar";

export default {
  name: "PageFooter",
  components: { ButtonBasic, LanguageBar },
  data: function() {
    return {
      scrollY: 0,
      show: true
    };
  },
  methods: {
    ...mapActions("modal", ["openModal"]),
    setFooterState() {
      let scrollPosition = scrollY()
      if (this.scrollY < scrollPosition) this.show = true;
      else if (this.scrollY > scrollPosition) this.show = false;
      this.scrollY = scrollPosition;
    },
    privacyPolicy() {
      this.openModal({
        component: "ModalPrivacyPolicy",
        title: this.lang.privacy
      });
    }
  },
  created: function() {
    window.addEventListener("scroll", this.setFooterState);
    this.setFooterState();
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.setFooterState);
  },
  computed: {
    ...mapGetters("languages", ["lang"])
  }
};
</script>

<style lang="scss" scoped>
#page-footer {
  @extend #{$page-footer-font-size};
  position: fixed;
  bottom: 0;
  width: 100%;
  height: $page-footer-height;
  line-height: $page-footer-height - $page-footer-padding * 2;
  padding: $page-footer-padding;
  background-color: $page-footer-background-color;
  vertical-align: middle;
}

.page-footer-enter-active,
.page-footer-leave-active {
  margin-bottom: 0;
  transition-property: margin-bottom;
  transition-duration: $page-footer-transition-duration;
  transition-timing-function: $page-footer-transition-timing-function;
}

.page-footer-enter,
.page-footer-leave-to {
  margin-bottom: -$page-footer-height;
}

.split {
  margin: 0 1vw;
}

.wcag {
  float: right;
  height: $page-footer-height - $page-footer-padding * 2;
}
</style>
